import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=3f8c697a"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=3f8c697a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports